const GAP = 8
const EDGE = 8
const MIN_HEIGHT = 100

export type PopoverPlacement = { top: number; left: number; maxHeight: number }

export function placeFlyout(anchor: DOMRect, width: number, height: number): PopoverPlacement {
  const vw = document.documentElement.clientWidth
  const vh = document.documentElement.clientHeight
  const spaceRight = vw - EDGE - (anchor.right + GAP)
  const spaceLeft = anchor.left - GAP - EDGE

  const left =
    width <= spaceRight || spaceRight >= spaceLeft
      ? anchor.right + GAP
      : Math.max(EDGE, anchor.left - GAP - width)

  const spaceBelowTop = vh - EDGE - anchor.top
  const maxHeight = Math.max(spaceBelowTop, MIN_HEIGHT)
  const top = Math.max(EDGE, Math.min(anchor.top, vh - EDGE - Math.min(height, maxHeight)))
  return { top, left, maxHeight: Math.min(height, maxHeight) }
}
